
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {serviceTabs} from "@/utils/tabs";
import {ServiceStore} from "@/store/modules/Services";
import {message} from "ant-design-vue";
import {RouterNameEnum} from "@/router/router.types";
import ServiceGeneralFormComponent from "@/UI/components/forms/serviceGeneral/ServiceGeneralForm.vue";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";

import moment from 'moment';
import {ServiceNomenclatureStore} from "@/store/modules/ServicesNomenclature";
import {ServicesCategoryNomenclatureStore} from "@/store/modules/ServicesCategoryNomenclature";
import {
  IServicesNomenclaturesListItem
} from "@/entity/servicesNomenclature/services.nomenclature.types";
import {
  IServicesCategoryNomenclature
} from "@/entity/servicesCategoryNomenclature/services.category.nomenclature.types";
import ServiceNomenclatureForm from "@/form/service/serviceNomenclature";
import {checkUserRole} from "@/router/Lib/helper";

@Component({
  components: {PageTitle, ServiceGeneralFormComponent, FormGroup},
  methods: {moment, checkUserRole}
})
export default class ServiceDetail extends Vue {

  tabs = serviceTabs;
  form = new ServiceNomenclatureForm();
  formReady = false;

  constructor() {
    super();
    moment().locale(this.$i18n.locale);
  }

  get service(): IServicesNomenclaturesListItem | null {
    return ServiceNomenclatureStore.service;
  }

  get servicesCategory(): IServicesCategoryNomenclature | null {
    return ServicesCategoryNomenclatureStore.items;
  }

  async editService(): Promise<void> {
    if (await this.form.submit(ServicesCategoryNomenclatureStore.update)) {
      await ServicesCategoryNomenclatureStore.fetchAll();
      this.form = new ServiceNomenclatureForm();
      await this.$router.push({name: this.$routeRules.Services})
    }
  }

  async created(): Promise<void> {
    await ServiceNomenclatureStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    await ServicesCategoryNomenclatureStore.fetchAll();

    this.formReady = true;

    if (this.service) {
      this.form.setFormData(this.service);
    }
  }

  handleTimeChange(value: any): void {
    this.form.service_duration = value.format('HH:mm');
    this.update();
  }

  async update(): Promise<void> {
    this.form.service_id = parseInt(this.$route.params.id);
    if (await this.form.submit(ServiceNomenclatureStore.update)) {
      await ServiceNomenclatureStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    }
  }

  async deleteService(): Promise<void> {
    if (await ServiceNomenclatureStore.delete({id: parseInt(this.$route.params.id)})) {
      message.success(i18nText("Данные успешно удалены"));
      await this.$router.push({name: RouterNameEnum.Services, params: {Studio: '0'}});
    } else {
      message.error(i18nText("Что то пошло не так..."))
    }
  }

  tabChanged(key: string): void {
    this.$router.push({name: key});
  }
}
